export { default } from './history-record-item'
